<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

    v-card(flat)
      v-card-title.px-5
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeDialog()" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.primary500--text {{ isEditing ? $t('pickup_address') : 'Setup Yezza Shipping' }}

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card-text.pa-0(v-else)
        v-form(ref="form")
          v-card.pa-4.mx-4.mb-12(outlined flat)
            .s1 {{ $t('enter_pickup_address') }}
            .c1.basic600--text {{ $t('enter_pickup_address_text') }}
            .address.mt-4
              address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="address")
              address-inputs(v-else :parentAddress.sync="address" :autofillPostcode="true")

            .company-phone
              div.label.basic600--text.text-uppercase {{$t('phone.label')}}
              v-text-field.mt-2(v-model='address.phone' :placeholder="$t('phone.placeholder')" dense outlined height="40" type="tel" background-color="basic200" :rules="rules.not_empty")
            
            //- div.awb.d-flex(v-if="!isEditing")
              y-checkbox.my-auto.mx-0.pa-0(v-model="same_for_awb_address" hide-details)
                template(v-slot:label)
                  .p1.my-auto Same as Air Waybill (AWB) address

        v-layout.ma-4(v-if="!isEditing")
          v-spacer
          v-btn(color='textColorAccent' depressed :loading="isLoading" @click="clickSave")
            .button-AA-medium.basic100--text {{ $t('save_and_continue') }}

</template>

<script>
import { mapActions } from 'vuex'
import AddressInputs from '@/components/AddressInputs.vue'
import AddressInputsId from '@/components/AddressInputsId.vue'

export default {
  name: 'CourierAddress',
  props: ['open', 'company', 'isEditing', 'courier'],
  components: { AddressInputs, AddressInputsId },
  data: () => ({
    isFetching: false,
    same_for_awb_address: false,
    address: {
      address_1: '',
      address_2: '',
      postcode: '',
      city: '',
      state: '',
      country: '',
      phone: ''
    },
    isFetchingAddress: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isIndoAddress () {
      if (this.$currency.code === 'IDR') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.address = this.courier.pickup_address
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog () {
      if (!this.isEditing) {
        this.showModal = !this.showModal
        return
      }
      if (!this.$refs.form.validate()) {
        return
      }
      this.courier.pickup_address = this.address
      this.showModal = !this.showModal
      this.$emit('check-address')
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = {
        pickup_address: this.address
      }
      this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/courier/${this.courier.id}`, params)
        .then(() => {
          this.showModal = false
          this.$emit('finished')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "pickup_address": "Pickup address",
    "enter_pickup_address": "Enter your pickup address",
    "enter_pickup_address_text": "This is where couriers would go to collect your packages for shipment.",
    "save_and_continue": "Save & Continue",
    "phone": {
      "label": "Phone number",
      "placeholder": "Enter phone number"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "pickup_address": "Alamat penjemputan",
    "enter_pickup_address": "Isi alamat penjemputan",
    "enter_pickup_address_text": "Di sinilah kurir akan pergi untuk mengambil paket kamu untuk pengiriman.",
    "save_and_continue": "Simpan & Teruskan",
    "phone": {
      "label": "Nomor HP",
      "placeholder": "Masukkan Nomor HP"
    },
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
  
    }
  }
}
</i18n>
